import React, { useEffect } from "react";

import useJobContext from "./useJobContext";
import { Tab, Tabs } from "@material-ui/core";
import useApplicantAccess from "customHooks/useAccess/useApplicantAccess";
import { useAuthState, useAuthorization } from "_ReactContext/AuthContext";
import { getTabsList } from "./JobTabsHelper";

const JobTabs = (props: any) => {
    const [data, dispatch] = useJobContext();
    const { dispatchGeneralPageInfo } = dispatch;
    const { isFeatureAuthorized } = useAuthorization();
    const { company } = useAuthState();

    const { t } = data;
    const { pageToRender } = data.LocalStateData;
    const applicantAccess = useApplicantAccess();
    const isJobRequestWithoutApplicantAccess =
        isFeatureAuthorized("JobRequestWithoutApplicantsAccess") ||
        isFeatureAuthorized("JobRequestWithoutApplicantsAndJobHistoryAccess");
    const isJobRequestWithoutJobHistoryAccess =
        isFeatureAuthorized("JobRequestWithoutJobHistoryAccess") ||
        isFeatureAuthorized("JobRequestWithoutApplicantsAndJobHistoryAccess");

    const PageToRenderLocalList = getTabsList(
        applicantAccess,
        data,
        isJobRequestWithoutApplicantAccess,
        isJobRequestWithoutJobHistoryAccess,
        company.whatsappEnabled === true &&
            company.whatsappApplicationEnabled === true
    );
    const currentValue = PageToRenderLocalList.indexOf(pageToRender);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        const newPageToRender = PageToRenderLocalList[newValue];
        dispatchGeneralPageInfo({
            type: "update",
            payload: { pageToRender: newPageToRender }
        });
    };
    useEffect(() => {
        if (pageToRender && !PageToRenderLocalList.includes(pageToRender)) {
            // If the current pageToRender is not in the list, reset it to the first
            dispatchGeneralPageInfo({
                type: "update",
                payload: { pageToRender: PageToRenderLocalList[0] }
            });
        }
    }, [
        pageToRender,
        JSON.stringify(PageToRenderLocalList),
        dispatchGeneralPageInfo
    ]);

    return (
        <Tabs
            value={currentValue}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="secondary"
            variant="scrollable"
        >
            {PageToRenderLocalList.map((tab, index) => (
                <Tab key={tab} label={t(`TabPage_${tab}`)} />
            ))}
        </Tabs>
    );
};

export default JobTabs;
